import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { getAsyncInjectors } from 'helpers/asyncInjectors';
import Setup, { ClinicSetup } from 'modules/Setup';
import { PlainLayout } from 'modules/Layout';
import { loggedInGuard } from '../guards';
import { getLoader } from '../helpers';
async function action(context) {
    const { route, store } = context;
    const Loader = getLoader(store);
    let Component = /*#__PURE__*/ _jsx(Loader, {});
    let redirect;
    if (process.env.BROWSER) {
        redirect = await loggedInGuard(context);
        if (redirect) return {
            redirect
        };
        const { injectSagas } = getAsyncInjectors(store);
        injectSagas(Setup.constants.MODULE_ID, Setup.sagas);
        Component = /*#__PURE__*/ _jsx(PlainLayout, {
            children: /*#__PURE__*/ _jsx(ClinicSetup, {})
        });
    }
    return {
        chunks: [
            'account'
        ],
        name: route.name,
        redirect,
        component: Component
    };
}
export default action;
